"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setFocusedInboxOnOff_1 = require("./actions/setFocusedInboxOnOff");
exports.setFocusedInboxOnOff = setFocusedInboxOnOff_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-focused-inbox-config/lib/lazyIndex.js
// module id = 2335
// module chunks = 56